import { render } from "./pageActivity.vue?vue&type=template&id=79bd858a&scoped=true"
import script from "./pageActivity.vue?vue&type=script&lang=js"
export * from "./pageActivity.vue?vue&type=script&lang=js"

import "./pageActivity.vue?vue&type=style&index=0&id=79bd858a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bd858a"]])

export default __exports__